// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify v3
// https://vuetifyjs.com/en/labs/introduction/#vuetify-labs
import { createVuetify, type ThemeDefinition } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import * as labs from 'vuetify/labs/components'

const tealTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: '#2196F3',  //blue
    secondary: '#9C7890',
    accent: '#909C78',   //#8b3740
    error: '#f44336',
    warning: '#ffc107',
    info: '#01579B',
    success: '#4caf50',
    jamzcare: '#607d8b', //blue-grey
  },
};

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  theme: {
    defaultTheme: "tealTheme",
    themes: {
        tealTheme
      }
  },
  // components,
  components: {
    ...labs,
    ...components,
  },
  directives
})
